export var urlQuestionList = '/api/XOrg/BookMaterial/getquestionlist';
export var urlQuestionSave = '/api/XOrg/BookMaterial/savequestion';
export var urlQuestionDel = '/api/XOrg/BookMaterial/deletequestion';
export var urlQuestionInfo = '/api/XOrg/BookMaterial/getquestioninfo';
export var urlUploadUrl = '/api/XOrg/BookMaterial/uploadExcel';
export var urlEditPaperQuestionFiles = '/api/XOrg/BookMaterial/editPaperQuestionFiles';
import http from 'lib/http'; // 获取题目列表

export function GetQuestionList(courseId, knowledgeId, keyvalue, queTypevalue, diffTypeValue, page, notset, pageSize, IsTest, IsNoPageing) {
  return http.get(urlQuestionList, {
    params: {
      courseId: courseId,
      knowledgeId: knowledgeId,
      keyvalue: keyvalue,
      queTypevalue: queTypevalue,
      diffTypeValue: diffTypeValue,
      page: page,
      notset: notset,
      pageSize: pageSize,
      IsTest: IsTest,
      IsNoPageing: IsNoPageing
    }
  });
} // 保存题目

export function SaveQuestion(courseId, knowledgeId, questionType, difficulty, content, correctSelectJson, analysis, selectJson, fileIds, analysisFileIds, questionId, answersIsDisorder) {
  return http.post(urlQuestionSave, {
    courseId: courseId,
    knowledgeId: knowledgeId,
    type: questionType,
    difficult: difficulty,
    content: content,
    correctSelectJson: correctSelectJson,
    selectJson: selectJson,
    fileIds: fileIds,
    analysisFileIds: analysisFileIds,
    analysis: analysis,
    questionId: questionId,
    answersIsDisorder: answersIsDisorder
  });
} // 删除题目

export function DelQuestion(questionId) {
  return http.post(urlQuestionDel, {
    questionId: questionId
  });
} // 编辑题目时获取题目信息

export function EditQuestion(questionId) {
  return http.get(urlQuestionInfo, {
    params: {
      questionId: questionId
    }
  });
}
export function UploadExcel(courseId, file) {
  return http.post(urlUploadUrl, {
    courseId: courseId,
    file: file
  });
}
/**
 * 保存综合题url
 */

export var urlSaveCombineQue = '/api/XOrg/BookMaterial/saveCombineQuestion';
/**
 * 保存综合题function
 */

export function saveCombineQue(content, knowledgeId, difficult, dataJson, courseId, files, questionId) {
  return http.post(urlSaveCombineQue, {
    content: content,
    knowledgeId: knowledgeId,
    difficult: difficult,
    dataJson: dataJson,
    courseId: courseId,
    files: files,
    questionId: questionId
  });
}
/**
 * 获取综合题详情url
 */

export var urlGetCombineQuestionInfo = "/XOrg/BookMaterial/getCombineQuestionInfo";
/**
 * 获取综合题详情function
 */

export function GetCombineQuestionInfo(questionId) {
  return http.post(urlGetCombineQuestionInfo, {
    questionId: questionId
  });
}
export function EditPaperQuestionFiles(questionId, type, fileId) {
  return http.post(urlEditPaperQuestionFiles, {
    questionId: questionId,
    type: type,
    fileId: fileId
  });
}